import gql from 'graphql-tag';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import HttpLinkServices from '../../../services/HttpLinkServices';

const dam_client = new ApolloClient({
  link: HttpLinkServices.dam,
  cache: new InMemoryCache(),
});

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const GET_CURSES = gql`
  query getCourses($category_id:Int!, $limit:Int!, $page:Int!){
    courses_collections(type:"online",category_id:$category_id, limit:$limit, page:$page){
      courses{
        id,title,thumbnail, description, hours, minutes
      }
    }
  }
  `;

const GET_CATEGORY = gql`
  query getCategory($category_id: Int!){
    category(id:$category_id){
      banner
    }
  }
`;

const GET_CATEGORIES = gql`{
    category_collections(parent:null, type_content: "courses"){
      categories{
        id,title
      }
    }
  }
  `;

const GET_SUBCATEGORIES = gql`
  query getCagegories($parent_id:Int!){
      category_collections(parent:$parent_id, type_content: "courses"){
        categories{
          id,title
        }
      }
    }
  `;

const GET_COURSE_HAS_USER_ITEM = gql`
    query course_has_user_item($course_id: Int!){
        course_has_user_item(course_id:$course_id) {
          id
        }
      }
  `;

const QUERY_QUANTIDADE_CURSOS = gql`
     query quantidadeCursos($category_id: Int) {
        courses_count(portoeduc: 1, category_id: $category_id) {
          count
        }
     }
  `;


export {
  dam_client,
  lms_client,
  GET_CURSES,
  GET_CATEGORIES,
  GET_SUBCATEGORIES,
  GET_COURSE_HAS_USER_ITEM,
  QUERY_QUANTIDADE_CURSOS,
  GET_CATEGORY,
};



// WEBPACK FOOTER //
// ./src/views/Courses/apollo/index.jsx